// extracted by mini-css-extract-plugin
export default {"container":"style_container__KM3jY","swiper":"style_swiper__vU7b0"};